import { PasswordStrength } from '@/components/PasswordStrengthBar'
import { mediumPasswordRegExp, strongPasswordRegExp } from './regExp'

export const checkPasswordStrength = (password: string): PasswordStrength => {
  if (strongPasswordRegExp.test(password)) {
    return 'strong'
  }

  if (mediumPasswordRegExp.test(password)) {
    return 'medium'
  }

  return 'weak'
}
